/* KAECE · Step 4 · the product page, v3 · 27.10.26 (Karan's picks)
   05 Find your size: a drawer from the right (a sheet from the bottom on the phone), like the bag, the Concierge and the
   allocation request. Opened by Find your size in 05, and by Size guide and Fit in the buy card. It answers as he types,
   shows the answer in the measurements, and Choose picks the size in the buy card (Secure opens the allocation request).
   05 G (27.10.26): the measurements beside the data sheet change with the size chosen.
   A sock answers from the shoe size. Delivery in the buy card goes to 07.
   07 The envelope: the card rises out once as the section comes into view; for reduced motion it simply sits out.
   28.10.26: the System has its own drawer, Find your sizes, for the tee, the short and the sock at once.
   Loads on every page; does nothing where these are absent. */
(function () {
  'use strict';

  /* the envelope is armed at once, so the card starts in the envelope before the section is reached */
  var envs = document.querySelectorAll('[data-k7-env]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (envs.length && !reduce && 'IntersectionObserver' in window) {
    [].forEach.call(envs, function (e) { e.classList.add('is-armed'); });
    var io = new IntersectionObserver(function (list) {
      list.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.45 });
    [].forEach.call(envs, function (e) { io.observe(e); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') setTimeout(fn, 0);
    else document.addEventListener('DOMContentLoaded', function () { setTimeout(fn, 0); });
  }
  ready(function () {
    initMeasure();
    var kz = document.querySelector('[data-kz]');
    if (kz) { if (kz.getAttribute('data-type') === 'system') initSystem(kz); else initSize(kz); }
    initLinks(kz);
  });

  /* ---------- 05 G · the measurements: choose a size and the figures change; the System switches garment ---------- */
  function initMeasure() {
    var box = document.querySelector('[data-k5m]');
    if (!box) return;
    var sets = [].slice.call(box.querySelectorAll('[data-k5m-i]'));
    var tabs = [].slice.call(box.querySelectorAll('[data-k5m-set]'));
    sets.forEach(function (set) {
      var rows = [];
      try { rows = JSON.parse(set.querySelector('[data-k5m-rows]').textContent) || []; } catch (err) { rows = []; }
      var figs = [].slice.call(set.querySelectorAll('[data-k5m-c]'));
      var chips = set.querySelector('[data-k5m-chips]');
      function select(s) {
        var r = null;
        rows.forEach(function (x) { if (x[0] === s) r = x; });
        if (!r) return;
        figs.forEach(function (el) { var c = parseInt(el.getAttribute('data-k5m-c'), 10); el.textContent = r[c] != null ? r[c] : ''; });
        [].forEach.call(chips.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === s ? 'true' : 'false'); });
      }
      set.k5mSelect = select;
      if (chips) chips.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) select(b.getAttribute('data-v')); });
    });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-k5m-set');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === tab ? 'true' : 'false'); });
        sets.forEach(function (s) { s.hidden = s.getAttribute('data-k5m-i') !== i; });
      });
    });
  }

  function scrollToEl(el) {
    if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
  }

  /* the buy card's links: Size guide and Fit open the drawer, Delivery goes to 07 */
  function initLinks(kz) {
    var sec = document.querySelector('[data-k5-sec]');
    if (!sec) return;
    window.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-kp-open], .kp-sg, [data-kz-open]');
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      if (a.getAttribute('data-kp-open') === 'delivery') { scrollToEl(document.getElementById('kp-promise') || sec); return; }
      if (kz && kz.kzOpen) { kz.kzOpen(a); return; }
      scrollToEl(sec);
    }, true);
  }

  /* ---------- 05 · Find your size ----------
     The suggestion rests on KAECE's own numbers: a garment he likes, measured flat, against the table;
     otherwise the size he usually wears. "Relaxed" sizes up one, as the fit notes say. A sock goes by the shoe size ranges.
     When the Concierge (Claude) is live, the same details go to it and its answer is shown. */
  function initSize(f) {
    var rows = [], head = [];
    try { rows = JSON.parse(f.querySelector('[data-k5-rows]').textContent) || []; } catch (err) { rows = []; }
    try { head = JSON.parse(f.querySelector('[data-k5-head]').textContent) || []; } catch (err) { head = []; }
    if (!rows.length) return;
    var wash = document.querySelector('[data-kz-wash]');
    document.body.appendChild(f);
    if (wash) document.body.appendChild(wash);

    var type = f.getAttribute('data-type') || 'fit';
    var col = parseInt(f.getAttribute('data-col'), 10) || 1;
    var what = f.getAttribute('data-what') || '';
    var where = f.getAttribute('data-where') || '';
    var tunit = f.getAttribute('data-tunit') || '';
    var ranges = [];
    try { ranges = JSON.parse(f.getAttribute('data-ranges') || '[]'); } catch (err) { ranges = []; }
    var unit = f.getAttribute('data-unit') || '';
    var athlete = f.getAttribute('data-a-name') ? {
      name: f.getAttribute('data-a-name'), h: f.getAttribute('data-a-h'), w: f.getAttribute('data-a-w'), s: f.getAttribute('data-a-s')
    } : null;
    var sizes = rows.map(function (r) { return r[0]; });
    var res = f.querySelector('[data-kz-res]');
    var big = f.querySelector('[data-k5-size]');
    var dims = f.querySelector('[data-kz-dims]');
    var why = f.querySelector('[data-k5-why]');
    var choose = f.querySelector('[data-k5-choose]');
    var ask = f.querySelector('[data-k5-ask]');
    var usualBox = f.querySelector('[data-k5-usual]');
    var prefBox = f.querySelector('[data-k5-pref]');
    var more = f.querySelector('[data-kz-more]');
    var mBox = f.querySelector('[data-kz-m]');
    var inH = f.querySelector('[name="k5-h"]'), inW = f.querySelector('[name="k5-w"]'), inM = f.querySelector('[name="k5-m"]'), inS = f.querySelector('[name="k5-shoe"]');
    var trs = [].slice.call(document.querySelectorAll('[data-k5-tr]'));
    var startText = why.textContent;
    var usual = null, pref = 'close', current = null, back = null;

    /* open and close */
    function open(from) {
      back = from || document.activeElement;
      f.classList.add('is-open');
      if (wash) wash.classList.add('is-open');
      document.documentElement.classList.add('kz-lock');
      setTimeout(function () { var first = f.querySelector('input, [data-k5-usual] button'); if (first && window.matchMedia('(min-width: 960px)').matches) first.focus(); }, 460);
    }
    function close() {
      f.classList.remove('is-open');
      if (wash) wash.classList.remove('is-open');
      document.documentElement.classList.remove('kz-lock');
      if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (err) {} }
    }
    f.kzOpen = open;
    f.querySelector('[data-kz-close]').addEventListener('click', close);
    if (wash) wash.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && f.classList.contains('is-open')) close(); });
    if (more && mBox) more.addEventListener('click', function () { mBox.hidden = false; more.hidden = true; if (inM) inM.focus(); });

    function num(el) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) && v > 0 ? v : null; }
    function press(box, v) {
      if (!box) return;
      [].forEach.call(box.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); });
    }
    function chipFor(s) {
      return [].filter.call(document.querySelectorAll('.template-product form[data-product-form] .product-form__chip'), function (c) {
        return c.textContent.replace(/\s+/g, ' ').trim() === s;
      })[0];
    }
    function mark(s) {
      trs.forEach(function (tr) {
        var hit = tr.getAttribute('data-size') === s;
        tr.classList.toggle('is-hit', hit);
        tr.classList.toggle('is-dim', !!s && !hit);
      });
      /* G: the answer shows in the measurements beside the data sheet */
      var m0 = document.querySelector('[data-k5m-i="0"]');
      if (s && m0 && m0.k5mSelect) m0.k5mSelect(s);
    }
    function dimsFor(i) {
      var bits = [];
      for (var k = 1; k < head.length && k < rows[i].length; k++) bits.push(String(head[k]).toLowerCase() + ' ' + rows[i][k] + (tunit ? ' ' + tunit : ''));
      return bits.length ? sizes[i] + ': ' + bits.join(' · ') : '';
    }
    function show(i, text) {
      why.textContent = text;
      if (i < 0) {
        current = null;
        res.classList.add('is-empty');
        big.textContent = '';
        dims.textContent = '';
        mark(null);
        choose.hidden = true;
        return;
      }
      current = sizes[i];
      res.classList.remove('is-empty');
      big.textContent = current;
      dims.textContent = dimsFor(i);
      mark(current);
      var c = chipFor(current);
      if (!c) { choose.hidden = true; return; }
      choose.hidden = false;
      choose.classList.remove('is-done');
      choose.textContent = (c.classList.contains('disabled') ? 'Secure ' : 'Choose ') + current;
    }
    function details(first) {
      var bits = [];
      if (type === 'shoe') { var n = num(inS); if (n) bits.push((first ? 'my shoe size is ' : 'shoe size ') + unit + ' ' + n); return bits.join(', '); }
      var h = num(inH), w = num(inW), m = num(inM);
      if (h) bits.push(h + 'cm');
      if (w) bits.push(w + 'kg');
      if (usual) bits.push((first ? 'I usually wear ' : 'usually wears ') + usual);
      if (m) bits.push(what.toLowerCase().replace('you like', first ? 'I like' : 'he likes') + ' measures ' + m + 'cm flat ' + where);
      bits.push((first ? 'I prefer ' : 'prefers ') + (pref === 'relaxed' ? 'a relaxed fit' : 'an athletic fit'));
      return bits.join(', ');
    }
    function note(i, t) {
      var c = chipFor(sizes[i]);
      if (!c) return t + ' The ' + sizes[i] + ' is not offered yet. Ask the Concierge.';
      if (c.classList.contains('disabled')) return t + ' The ' + sizes[i] + ' is allocated: request priority access when it is released.';
      return t;
    }
    function localShoe() {
      var n = num(inS);
      if (!n) { show(-1, startText); return null; }
      var hit = -1;
      ranges.forEach(function (r, j) { if (n >= +r[1] && n <= +r[2]) hit = j; });
      if (hit < 0) {
        var lo = null, hi = null;
        ranges.forEach(function (r) { if (+r[2] < n) lo = r; if (+r[1] > n && !hi) hi = r; });
        var say = lo && hi
          ? unit + ' ' + n + ' sits between ' + lo[0] + ' (' + unit + ' ' + lo[1] + '-' + lo[2] + ') and ' + hi[0] + ' (' + unit + ' ' + hi[1] + '-' + hi[2] + '). Ask the Concierge which suits you.'
          : unit + ' ' + n + ' is outside the sizes made: ' + ranges.map(function (r) { return r[0] + ' is ' + unit + ' ' + r[1] + '-' + r[2]; }).join(', ') + '.';
        show(-1, say);
        return null;
      }
      var i = sizes.indexOf(ranges[hit][0]);
      show(i, note(i, unit + ' ' + n + ' is in the ' + sizes[i] + ' range, ' + unit + ' ' + ranges[hit][1] + '-' + ranges[hit][2] + '.'));
      return sizes[i];
    }
    function localFit() {
      var h = num(inH), w = num(inW), m = num(inM);
      var i = -1, t = '';
      if (m) {
        var best = 0;
        rows.forEach(function (r, j) {
          var v = parseFloat(r[col]), bv = parseFloat(rows[best][col]);
          var d = Math.abs(v - m), bd = Math.abs(bv - m);
          if (d < bd || (d === bd && v > bv)) best = j;
        });
        i = best;
        t = what + ' measures ' + m + ' cm ' + where + '. The ' + sizes[i] + ' measures ' + rows[i][col] + ' cm.';
      } else if (usual) {
        i = sizes.indexOf(usual);
        t = 'You usually wear ' + usual + '.';
      } else {
        show(-1, startText);
        return null;
      }
      if (pref === 'relaxed') {
        if (i < sizes.length - 1) { i += 1; t += ' Sized up one for a more relaxed profile.'; }
        else { t += ' ' + sizes[i] + ' is the largest size.'; }
      }
      if (athlete && (h || w)) t += ' For reference, ' + athlete.name + ' is ' + athlete.h + 'cm / ' + athlete.w + 'kg and wears ' + athlete.s + '.';
      show(i, note(i, t));
      return sizes[i];
    }
    function local() { return type === 'shoe' ? localShoe() : localFit(); }
    function ai(fallback) {
      var cfg = window.KAECE_CONCIERGE || {};
      if (!cfg.endpoint) return;
      var q = 'Size for the ' + (f.getAttribute('data-product') || 'garment') + ': ' + details() + '. Reply as "SIZE: X" and then one or two sentences why, using only the measurements and fit notes.';
      why.textContent = 'Asking the Concierge…';
      fetch(cfg.endpoint.replace(/\/$/, '') + '/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: [{ role: 'user', content: q }], context: { page: location.pathname } })
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (txt) {
          var m = txt.match(/SIZE:\s*([A-Z\/]{1,4})\b/i);
          var s = m ? m[1].toUpperCase() : fallback;
          var i = sizes.indexOf(s); if (i < 0) i = sizes.indexOf(fallback);
          show(i, txt.replace(/SIZE:\s*[A-Z\/]+\.?\s*/i, '').trim());
        })
        .catch(function () { local(); });
    }
    var wait = null;
    function run() {
      var s = local();
      clearTimeout(wait);
      if (s) wait = setTimeout(function () { ai(s); }, 900);
    }
    if (usualBox) usualBox.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      usual = usual === b.getAttribute('data-v') ? null : b.getAttribute('data-v');
      press(usualBox, usual);
      run();
    });
    if (prefBox) prefBox.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      pref = b.getAttribute('data-v'); press(prefBox, pref);
      run();
    });
    [inH, inW, inM, inS].forEach(function (el) { if (el) el.addEventListener('input', run); });
    choose.addEventListener('click', function () {
      if (!current) return;
      var c = chipFor(current);
      if (!c) return;
      var allocated = c.classList.contains('disabled');
      c.click();
      if (allocated) {
        /* an allocated size: Secure allocation opens the request drawer (kaece-product.js) */
        close();
        var tries = 0;
        (function openAlloc() {
          var b = document.querySelector('#klaviyo-bis-button-container button');
          var bar = document.querySelector('.kp-add');
          if (b && b.offsetParent) { b.click(); return; }
          if (++tries > 15) { if (bar && /secure/i.test(bar.textContent)) bar.click(); return; }
          setTimeout(openAlloc, 100);
        })();
        return;
      }
      choose.textContent = current + ' chosen';
      choose.classList.add('is-done');
      setTimeout(close, 700);
    });
    ask.addEventListener('click', function () {
      var q = 'What size am I in the ' + (f.getAttribute('data-product') || 'garment') + '? ' + details(true) + '.';
      close();
      if (window.KAECE && window.KAECE.concierge) window.KAECE.concierge.open(q);
    });
  }

  /* ---------- 05 · Find your sizes, the System (28.10.26) ----------
     One drawer for the three pieces. The tee and the short answer from the size he usually wears ("Relaxed" sizes up one),
     the sock from the shoe size. Choose sets all three in the buy card. The figures come from the System's own tables. */
  function initSystem(f) {
    var tables = [];
    try { tables = JSON.parse(f.querySelector('[data-kz-tables]').textContent) || []; } catch (err) { tables = []; }
    if (!tables.length) return;
    var wash = document.querySelector('[data-kz-wash]');
    document.body.appendChild(f);
    if (wash) document.body.appendChild(wash);

    var res = f.querySelector('[data-kz-res]');
    var why = f.querySelector('[data-k5-why]');
    var choose = f.querySelector('[data-k5-choose]');
    var ask = f.querySelector('[data-k5-ask]');
    var usualBox = f.querySelector('[data-k5-usual]');
    var prefBox = f.querySelector('[data-k5-pref]');
    var outs = [].slice.call(f.querySelectorAll('[data-kz-p]'));
    var inH = f.querySelector('[name="k5-h"]'), inW = f.querySelector('[name="k5-w"]'), inS = f.querySelector('[name="k5-shoe"]');
    var ref = f.getAttribute('data-ref') || '';
    var startText = why.textContent;
    var usual = null, pref = 'close', picks = [], back = null;

    function open(from) {
      back = from || document.activeElement;
      f.classList.add('is-open');
      if (wash) wash.classList.add('is-open');
      document.documentElement.classList.add('kz-lock');
      setTimeout(function () { var first = f.querySelector('input'); if (first && window.matchMedia('(min-width: 960px)').matches) first.focus(); }, 460);
    }
    function close() {
      f.classList.remove('is-open');
      if (wash) wash.classList.remove('is-open');
      document.documentElement.classList.remove('kz-lock');
      if (back && back.focus) { try { back.focus({ preventScroll: true }); } catch (err) {} }
    }
    f.kzOpen = open;
    f.querySelector('[data-kz-close]').addEventListener('click', close);
    if (wash) wash.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && f.classList.contains('is-open')) close(); });

    function num(el) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) && v > 0 ? v : null; }
    function press(box, v) {
      if (!box) return;
      [].forEach.call(box.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-v') === v ? 'true' : 'false'); });
    }
    function low(t) { return String(t.title || '').toLowerCase(); }
    function isShoe(t) { return t.head && String(t.head[1]).toUpperCase() === 'UK'; }
    function chip(t, s) {
      var box = document.querySelector('.template-product form[data-product-form] [class*="kopt-"][class*="_' + low(t) + '"]');
      if (!box || !s) return null;
      return [].filter.call(box.querySelectorAll('.product-form__chip'), function (c) { return c.textContent.replace(/\s+/g, ' ').trim() === s; })[0] || null;
    }
    function shoe(t, n) {
      var hit = null;
      t.rows.forEach(function (r) { var p = String(r[1]).split('-'); if (n >= +p[0] && n <= +p[p.length - 1]) hit = r[0]; });
      return hit;
    }
    function details(first) {
      var bits = [], h = num(inH), w = num(inW), n = num(inS);
      if (h) bits.push(h + 'cm');
      if (w) bits.push(w + 'kg');
      if (usual) bits.push((first ? 'I usually wear ' : 'usually wears ') + usual);
      if (n) bits.push((first ? 'my shoe size is UK ' : 'shoe size UK ') + n);
      bits.push((first ? 'I prefer ' : 'prefers ') + (pref === 'relaxed' ? 'a relaxed fit' : 'an athletic fit'));
      return bits.join(', ');
    }
    function run() {
      var n = num(inS), say = [], top = false;
      picks = tables.map(function (t) {
        var sizes = t.rows.map(function (r) { return r[0]; });
        if (isShoe(t)) {
          if (!n) return null;
          var s = shoe(t, n);
          if (s) {
            var row = t.rows[sizes.indexOf(s)];
            say.push('UK ' + n + ' is in the ' + s + ' ' + low(t) + ' range, UK ' + row[1] + '.');
          } else {
            say.push('UK ' + n + ' is outside the ' + low(t) + ' sizes: ' + t.rows.map(function (r) { return r[0] + ' is UK ' + r[1]; }).join(', ') + '. Ask the Concierge.');
          }
          return s;
        }
        if (!usual) return null;
        var i = sizes.indexOf(usual);
        if (i < 0) return null;
        if (pref === 'relaxed') { if (i < sizes.length - 1) i += 1; else top = true; }
        return sizes[i];
      });
      if (usual) {
        var lead = 'You usually wear ' + usual + '.';
        if (pref === 'relaxed') lead += top ? ' ' + usual + ' is the largest size.' : ' Sized up one for a more relaxed profile.';
        say.unshift(lead);
      }
      if (ref && (num(inH) || num(inW))) say.push(ref);
      var any = false, chosen = [];
      tables.forEach(function (t, i) {
        var s = picks[i];
        if (outs[i]) outs[i].textContent = s || '';
        if (!s) return;
        any = true;
        chosen.push(low(t));
        var c = chip(t, s);
        if (!c) say.push('The ' + low(t) + ' in ' + s + ' is not offered in the System yet. Ask the Concierge.');
        else if (c.classList.contains('disabled')) say.push('The ' + low(t) + ' in ' + s + ' is allocated: request priority access when it is released.');
        var m = document.querySelector('[data-k5m-i="' + i + '"]');
        if (m && m.k5mSelect) m.k5mSelect(s);
      });
      res.classList.toggle('is-empty', !any);
      why.textContent = say.length ? say.join(' ') : startText;
      if (!any) { choose.hidden = true; return; }
      choose.hidden = false;
      choose.classList.remove('is-done');
      choose.textContent = chosen.length === tables.length ? 'Choose these sizes' : 'Choose the ' + chosen.join(' and ');
    }
    if (usualBox) usualBox.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      usual = usual === b.getAttribute('data-v') ? null : b.getAttribute('data-v');
      press(usualBox, usual);
      run();
    });
    if (prefBox) prefBox.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      pref = b.getAttribute('data-v'); press(prefBox, pref);
      run();
    });
    [inH, inW, inS].forEach(function (el) { if (el) el.addEventListener('input', run); });
    choose.addEventListener('click', function () {
      var done = 0;
      tables.forEach(function (t, i) {
        var c = chip(t, picks[i]);
        if (!c) return;
        if (!c.classList.contains('selected')) c.click();
        done += 1;
      });
      if (!done) return;
      choose.textContent = 'Sizes chosen';
      choose.classList.add('is-done');
      setTimeout(close, 700);
    });
    ask.addEventListener('click', function () {
      var q = 'What sizes am I in the ' + (f.getAttribute('data-product') || 'System') + '? ' + details(true) + '.';
      close();
      if (window.KAECE && window.KAECE.concierge) window.KAECE.concierge.open(q);
    });
  }
})();
